import { Box, Stack } from "@mui/material";

import { useDebouncedInputValueWithSetValue } from "../hooks/components";
import { isNumeric } from "../utils/dataManipulation";
import { formatNumberBasedOnUser } from "../utils/namesManipulation";
import { cn } from "../utils/styling";
import { Slider } from "./Slider";

export const NumericRangePicker = ({
  changeBySlider = true,
  changeByTyping,
  className = "",
  debounceTime = 300,
  label = "",
  max,
  min,
  setValue,
  step,
  style = {},
  value,
  ...props
}) => {
  const { handleChange, inputValue } = useDebouncedInputValueWithSetValue({
    debounceTime,
    setValue,
    value,
  });

  const handleSliderValueChange = (event, newValue) => {
    handleChange(newValue);
  };

  const sliderValue = [inputValue?.[0], inputValue?.[1]];
  const valueIsNotSelected = !isNumeric(inputValue?.[0]) || !isNumeric(inputValue?.[1]);

  const inputClassName = "font-ds-number-regular-xs w-20 rounded px-1 border-ds-subtle !border-[2px]";
  return (
    <div
      className={cn(
        "h-12 rounded-ds-0-5x bg-lds-surface-bright font-ds-body-regular-md",
        !changeBySlider && "flex h-10 flex-col justify-center",
        className,
        valueIsNotSelected ? "border-ds-strong" : "border-ds-accent"
      )}
      style={{
        backgroundColor: "var(--color-surface-bright)",
        padding: "4px 12px",
        ...style,
      }}
      {...props}
    >
      <Stack className="w-full justify-between">
        <span className="block w-1/2 truncate font-ds-label-sm">{label}</span>
        <Stack className=" " gap={1}>
          {changeByTyping && (
            <>
              <input
                className={inputClassName}
                onChange={(e) => handleChange([e.target.value, sliderValue[1]])}
                value={formatNumberBasedOnUser(sliderValue[0])}
              />
              <span>-</span>
              <input
                className={inputClassName}
                onChange={(e) => handleChange([sliderValue[0], e.target.value])}
                value={formatNumberBasedOnUser(sliderValue[1])}
              />
            </>
          )}
          {!changeByTyping && (
            <>
              <span className="font-ds-number-regular-xs">{formatNumberBasedOnUser(sliderValue[0])}</span>
              <span>-</span>
              <span className="font-ds-number-regular-xs">{formatNumberBasedOnUser(sliderValue[1])}</span>
            </>
          )}
        </Stack>
      </Stack>
      {changeBySlider && (
        <div className="mt-1 w-full">
          <Box className="flex items-center gap-3 font-ds-number-regular-md">
            <span>{formatNumberBasedOnUser(min)}</span>
            <Slider
              max={max}
              min={min}
              onChange={handleSliderValueChange}
              size="small"
              step={step ?? (min < 1 ? 0.01 : max < 10 ? 0.1 : 1)}
              sx={{
                padding: "2px",
              }}
              value={sliderValue}
              valueLabelDisplay="off"
            />
            <span>{formatNumberBasedOnUser(max)}</span>
          </Box>
        </div>
      )}
    </div>
  );
};
